import Avatar from 'components/Profile/components/Avatar/ver2';
import PersonalDetails from 'components/Profile/components/PersonalDetails';
import ProfileBodyMobile from 'components/Profile/components/ProfileBody/mobile/ver2';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterFitHeight from 'components/common/CollapsibleSideMenu/OuterFitHeight';
import OuterPathContent from 'components/common/CollapsibleSideMenu/OuterPathContent';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React from 'react';

const ProfilePage = () => {
  const { isMobile, isTablet } = useDetectDevice();

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <Avatar />
        <ProfileBodyMobile />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent>
          <OuterFitHeight>
            <PersonalDetails />
          </OuterFitHeight>
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export default ProfilePage;
